import React, { ReactElement, useEffect, useState } from 'react';
import {
  Col, Input, Label, LoaderButton, Row,
} from 'idsk-react-components';
import { useNavigate } from 'react-router';
import { BackButton } from 'slovlex-idsk-react-components';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import Tezaurus from '../../../../model/Tezaurus';
import { updateTezaurus } from '../../../../client/tezaurus/tezaurusUpdateClient';
import './tezaurusEditForm.scss';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface TezaurusEditProps {
  tezaurusData: Tezaurus
}
const TezaurusEditForm = ({ tezaurusData }: TezaurusEditProps): ReactElement => {
  const [tezaurus, setTezaurus] = useState<Tezaurus>(
    {
      uuid: tezaurusData.uuid,
      nazov: tezaurusData.nazov,
    },
  );
  const {
    wrapClient: updateTezaurusClient,
    status: updateTezaurusStatus,
  } = useClient(updateTezaurus);
  const { handleStatus } = useClientStatusContext();

  useEffect(() => {
    if (updateTezaurusStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateTezaurusStatus, handleStatus]);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();

  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  function updateNazov({ target }): void {
    setTezaurus({ ...tezaurus, nazov: target.value });
    clearFieldErrorMessage('nazov');
  }

  async function updateTezaurusSubmit(event): Promise<void> {
    event.preventDefault();
    await updateTezaurusClient(tezaurus);
    navigate(routes.tezaurus.admin.list);
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  }

  return (
    <form>
      <Row>
        <Col width="one-half">
          <Label htmlFor="nazov">Názov</Label>
        </Col>
      </Row>
      <Row className="tezaurus-update__nazov-input">
        <Col width="one-half">
          <Input
            key="nazov"
            type="text"
            maxLength={128}
            value={tezaurus.nazov}
            onChange={(event) => updateNazov(event)}
            error={getFieldErrorMessage && getFieldErrorMessage('nazov')}
          />
        </Col>
      </Row>
      <Row>
        <Col width="one-half">
          <LoaderButton
            type="submit"
            className="tezaurus-update__update-button"
            loading={updateTezaurusStatus.loading}
            onClick={event => updateTezaurusSubmit(event)}
            size="large"
          >Uložiť zmeny
          </LoaderButton>
          <BackButton />
        </Col>
      </Row>
    </form>
  );
};

export default TezaurusEditForm;
